import { render } from "./AutocompleteInput.vue?vue&type=template&id=ef086dd0&ts=true"
import script from "./AutocompleteInput.vue?vue&type=script&lang=ts"
export * from "./AutocompleteInput.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__